import React from 'react';
import { Skeleton } from '@components/ui/skeleton';
const ProductSingleDetailsLoader: React.FC = () => {
  return <div className="block lg:grid grid-cols-9 gap-x-10 xl:gap-x-14 pt-7 pb-10 lg:pb-14 2xl:pb-20 items-start animate-pulse" data-sentry-component="ProductSingleDetailsLoader" data-sentry-source-file="ProductSingleDetailsSkeleton.tsx">
      <div className="col-span-5">
        <Skeleton className="w-96 h-96 2xl:w-[600px] 2xl:h-[600px] 2xl:mr-[250px] xl:max-w-[550px] xl:h-[550px] xl:mr-[130px] lg:w-full lg:mr-[100px] mx-auto mb-4" aria-hidden="true" data-sentry-element="Skeleton" data-sentry-source-file="ProductSingleDetailsSkeleton.tsx" />
        {/* <div className="flex gap-2 justify-center items-center mt-4 mx-auto lg:mr-10">
          {[...Array(3)].map((_, idx) => (
            <Skeleton
              key={idx}
              className="w-16 h-16 rounded overflow-hidden p-1 border border-neutral-200"
              aria-hidden="true"
            />
          ))}
         </div> */}
      </div>
      <div className="col-span-4 pt-8 lg:pt-0">
        <div className="pb-7 mb-7 border-b border-neutral-300 dark:border-neutral-800">
          <Skeleton className="h-8 w-3/4 mb-3.5" aria-hidden="true" data-sentry-element="Skeleton" data-sentry-source-file="ProductSingleDetailsSkeleton.tsx" />
          <div className="flex flex-col mt-2">
            <Skeleton className="h-6 w-12 mb-2" aria-hidden="true" data-sentry-element="Skeleton" data-sentry-source-file="ProductSingleDetailsSkeleton.tsx" />
            <Skeleton className="h-6 w-16 mt-2" aria-hidden="true" data-sentry-element="Skeleton" data-sentry-source-file="ProductSingleDetailsSkeleton.tsx" />
          </div>
          <Skeleton className="h-10 w-32 mt-5" aria-hidden="true" data-sentry-element="Skeleton" data-sentry-source-file="ProductSingleDetailsSkeleton.tsx" />
        </div>
        <div className="pb-3 border-b border-neutral-300 dark:border-neutral-800">
          <Skeleton className="h-4 w-full mb-2" aria-hidden="true" data-sentry-element="Skeleton" data-sentry-source-file="ProductSingleDetailsSkeleton.tsx" />
          <Skeleton className="h-4 w-full mb-2" aria-hidden="true" data-sentry-element="Skeleton" data-sentry-source-file="ProductSingleDetailsSkeleton.tsx" />
          <Skeleton className="h-4 w-5/6" aria-hidden="true" data-sentry-element="Skeleton" data-sentry-source-file="ProductSingleDetailsSkeleton.tsx" />
        </div>
        <div className="flex items-center gap-x-4 border-b border-neutral-300 dark:border-neutral-800 py-8">
          <Skeleton className="h-12 w-24" aria-hidden="true" data-sentry-element="Skeleton" data-sentry-source-file="ProductSingleDetailsSkeleton.tsx" />
          <Skeleton className="h-12 w-48" aria-hidden="true" data-sentry-element="Skeleton" data-sentry-source-file="ProductSingleDetailsSkeleton.tsx" />
        </div>
        <div className="py-6">
          <div className="flex justify-between items-center">
            <Skeleton className="h-4 w-1/4" aria-hidden="true" data-sentry-element="Skeleton" data-sentry-source-file="ProductSingleDetailsSkeleton.tsx" />
            <div className="flex space-x-2">
              <Skeleton className="h-6 w-6 rounded-full" aria-hidden="true" data-sentry-element="Skeleton" data-sentry-source-file="ProductSingleDetailsSkeleton.tsx" />
              <Skeleton className="h-6 w-6 rounded-full" aria-hidden="true" data-sentry-element="Skeleton" data-sentry-source-file="ProductSingleDetailsSkeleton.tsx" />
              <Skeleton className="h-6 w-6 rounded-full" aria-hidden="true" data-sentry-element="Skeleton" data-sentry-source-file="ProductSingleDetailsSkeleton.tsx" />
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default ProductSingleDetailsLoader;